import { useThemeStatusStore } from 'store/themeStatus.store';

import { LineChart } from 'components/common/charts/lineChart/lineChart';

import {
    Data,
    getCardGraphSeriesAndOptions,
} from 'components/widgets/ProjectSummary/components/CardsSection/components/CardGraph/CardGraph.utils';

interface Props {
    data: Data[];
    xaxisTitle: string;
    yaxisTitle: string;
    yAxisMaxValue: number | undefined;
    height?: number | string;
    className?: string;
    serializeData: ({
        data,
        themeStatus,
    }: {
        data: Data;
        themeStatus: boolean;
    }) => ApexAxisChartSeries | ApexNonAxisChartSeries | undefined;
    serializeOptions: ({
        data,
        themeStatus,
        xaxisTitle,
        yaxisTitle,
        yAxisMaxValue,
    }: {
        data: Data;
        themeStatus: boolean;
        xaxisTitle: string;
        yaxisTitle: string;
        yAxisMaxValue: number | undefined;
    }) => ApexCharts.ApexOptions;
}

export const CardGraph = ({
    data,
    xaxisTitle,
    yaxisTitle,
    yAxisMaxValue,
    height,
    className,
    serializeData,
    serializeOptions,
}: Props) => {
    const { themeStatus } = useThemeStatusStore();

    const { series, options } = getCardGraphSeriesAndOptions(
        data,
        themeStatus,
        xaxisTitle,
        yaxisTitle,
        yAxisMaxValue,
        serializeData,
        serializeOptions,
    );

    return (
        <LineChart
            series={series}
            options={options}
            noData={false}
            isFetching={false}
            height={height ?? 300}
            className={className}
        />
    );
};
